import type { HeroConfig } from '@src/components/sco/LayoutBlocks/Hero/types'

export const eventsLandingHeroConfig: HeroConfig = {
  title: 'Real Expert Advisory',
  description: 'How can we grow your startup today?',
  backgroundColor: 'colorPalette.bg',
  backgroundGradient: 'linear(to-t, blackAlpha.500 25%, transparent 75%)',
  howItWorksCards: [
    {
      title: 'Pick a topic',
      description: 'Choose from courses, videos, and expert playbooks tailored to your stage.',
      image: require('@public/assets/graphics/explainer/your-request.png'),
    },
    {
      title: 'Get a guided path',
      description: 'Follow a step-by-step learning track that keeps you moving forward.',
      image: require('@public/assets/graphics/explainer/get-matched.png'),
    },
    {
      title: 'Apply it immediately',
      description: 'Turn lessons into action with practical next steps for your startup.',
      image: require('@public/assets/graphics/explainer/focus-on-tasks.png'),
    },
  ],
}
